package fr.manyverse.app.presentation.auth

import androidx.compose.runtime.Composable

@Composable
internal actual fun rememberGoogleLauncher(onFallback: () -> Unit): () -> Unit = onFallback
